(function () {
  'use strict';

  if (window.__MOTO_WISHLIST_BRIDGE_BOUND) {
    return;
  }

  var wishlistKey = 'motoavenueWishlist';

  var escapeHtml = function (value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  var isLocalPreview = function () {
    return /^(127\.0\.0\.1|localhost)$/i.test(window.location.hostname);
  };

  var hasKnownWishlistApp = function () {
    if (window._swat || window.SWYM || window.SwymCallbacks || window.WishlistKing || window.AppmateWishlist) {
      return true;
    }

    return Array.prototype.some.call(document.scripts, function (script) {
      var src = script.src || '';
      return /swym|wishlistking|appmate|wishlist-favorites|apps\/wishlist/i.test(src);
    });
  };

  var shouldRunFallback = function () {
    if (isLocalPreview()) {
      return true;
    }

    return !hasKnownWishlistApp();
  };

  var parseWishlist = function () {
    try {
      var stored = window.localStorage.getItem(wishlistKey);
      var parsed = stored ? JSON.parse(stored) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  var saveWishlist = function (items) {
    try {
      window.localStorage.setItem(wishlistKey, JSON.stringify(items));
    } catch (error) {
      return;
    }

    document.dispatchEvent(new CustomEvent('moto:wishlist-updated', {
      detail: { items: items }
    }));
  };

  var buildWishlistId = function (item) {
    var seed = item.handle || item.variantId || item.productId || item.url || item.title || '';
    return String(seed).trim().toLowerCase().replace(/\s+/g, '-');
  };

  var normalizeWishlistItem = function (item) {
    return {
      id: item.id || buildWishlistId(item),
      productId: item.productId || '',
      variantId: item.variantId || '',
      handle: item.handle || '',
      title: item.title || 'Product',
      url: item.url || '#',
      image: item.image || '',
      vendor: item.vendor || 'Moto Avenue',
      price: item.price || '',
      comparePrice: item.comparePrice || '',
      badge: item.badge || ''
    };
  };

  var getWishlistItems = function () {
    return parseWishlist().map(normalizeWishlistItem);
  };

  var findCard = function (node) {
    return node ? node.closest('.product-card-wrapper, .card-wrapper, .product-card') : null;
  };

  var findProductDetails = function (node) {
    return node ? node.closest('.pdp-info-card, [data-product-details]') : null;
  };

  var findWishlistRow = function (node) {
    return node ? node.closest('.ma-wishlist-item') : null;
  };

  var getHandleFromPath = function () {
    var match = window.location.pathname.match(/^\/products\/([^\/]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  var findVariantInput = function (scope) {
    if (!scope) {
      return null;
    }

    var variantInput = scope.querySelector('input[name="id"]');
    if (variantInput) {
      return variantInput;
    }

    var form = scope.querySelector('product-form, form');
    if (form) {
      variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        return variantInput;
      }
      if (form.shadowRoot) {
        return form.shadowRoot.querySelector('input[name="id"]');
      }
    }

    var customForm = scope.querySelector('product-form');
    if (customForm && customForm.shadowRoot) {
      return customForm.shadowRoot.querySelector('input[name="id"]');
    }

    return null;
  };

  var getVariantId = function (scope) {
    var variantInput = findVariantInput(scope);
    if (variantInput) {
      return variantInput.value;
    }

    return scope ? (scope.getAttribute('data-variant-id') || scope.getAttribute('data-product-id') || '') : '';
  };

  var extractFromCard = function (button, card) {
    var link = card.querySelector('.card__heading a, .title a, .title .link, .product-card__content a[href]');
    var image = card.querySelector('.card__media img, .product-card__thumb img');
    var price = card.querySelector('.price-item--regular, .product-card__price .text-heading');
    var comparePrice = card.querySelector('.price-item--sale, .product-card__price .text-decoration-line-through, s, del');
    var vendor = card.querySelector('.card-information .caption-with-letter-spacing, .text-gray-500.text-xs');
    var badge = card.querySelector('.card__badge, .product-card__badge');

    return normalizeWishlistItem({
      id: button.getAttribute('data-wishlist-id') || card.getAttribute('data-wishlist-id') || '',
      productId: button.getAttribute('data-shopify-product-id') || card.getAttribute('data-shopify-product-id') || '',
      variantId: button.getAttribute('data-variant-id') || card.getAttribute('data-variant-id') || card.getAttribute('data-product-id') || '',
      handle: button.getAttribute('data-product-handle') || card.getAttribute('data-product-handle') || card.getAttribute('data-wishlist-id') || '',
      title: button.getAttribute('data-compare-title') || card.getAttribute('data-product-title') || (link ? link.textContent.trim() : ''),
      url: link ? link.getAttribute('href') : '#',
      image: button.getAttribute('data-compare-image') || card.getAttribute('data-product-image') || (image ? (image.currentSrc || image.getAttribute('src') || '') : ''),
      vendor: button.getAttribute('data-compare-vendor') || card.getAttribute('data-product-vendor') || (vendor ? vendor.textContent.trim() : ''),
      price: button.getAttribute('data-compare-price') || card.getAttribute('data-product-price') || (price ? price.textContent.replace(/\s+/g, ' ').trim() : ''),
      comparePrice: button.getAttribute('data-compare-compare-price') || (comparePrice ? comparePrice.textContent.replace(/\s+/g, ' ').trim() : ''),
      badge: badge ? badge.textContent.replace(/\s+/g, ' ').trim() : ''
    });
  };

  var extractFromDetails = function (button, details) {
    var title = details.querySelector('.pdp-title, h1, h5');
    var image = document.querySelector('.pdp-gallery-main img, .product-details__thumb-slider img, .product__media img');
    var price = details.querySelector('.pdp-price-current, h4');
    var comparePrice = details.querySelector('.pdp-price-original, .text-decoration-line-through');

    return normalizeWishlistItem({
      id: button.getAttribute('data-wishlist-id') || details.getAttribute('data-wishlist-id') || '',
      productId: button.getAttribute('data-shopify-product-id') || details.getAttribute('data-shopify-product-id') || '',
      variantId: getVariantId(details),
      handle: button.getAttribute('data-product-handle') || details.getAttribute('data-product-handle') || details.getAttribute('data-wishlist-id') || '',
      title: details.getAttribute('data-product-title') || (title ? title.textContent.trim() : ''),
      url: details.getAttribute('data-url') || window.location.pathname,
      image: details.getAttribute('data-product-image') || (image ? (image.currentSrc || image.getAttribute('src') || '') : ''),
      vendor: details.getAttribute('data-product-vendor') || '',
      price: details.getAttribute('data-product-price') || (price ? price.textContent.replace(/\s+/g, ' ').trim() : ''),
      comparePrice: comparePrice ? comparePrice.textContent.replace(/\s+/g, ' ').trim() : ''
    });
  };

  var extractFromWishlistRow = function (button, row) {
    var link = row.querySelector('.ma-wishlist-item__body h3 a');
    var image = row.querySelector('.ma-wishlist-item__media img');
    var vendor = row.querySelector('.ma-wishlist-item__vendor');
    var price = row.querySelector('.ma-wishlist-item__price strong');
    var comparePrice = row.querySelector('.ma-wishlist-item__price span');

    return normalizeWishlistItem({
      id: button.getAttribute('data-wishlist-id') || row.getAttribute('data-wishlist-id') || '',
      title: link ? link.textContent.trim() : '',
      url: link ? link.getAttribute('href') : '#',
      image: image ? (image.currentSrc || image.getAttribute('src') || '') : '',
      vendor: vendor ? vendor.textContent.trim() : '',
      price: price ? price.textContent.replace(/\s+/g, ' ').trim() : '',
      comparePrice: comparePrice ? comparePrice.textContent.replace(/\s+/g, ' ').trim() : ''
    });
  };

  var extractWishlistItem = function (button) {
    var card = findCard(button);
    if (card) {
      return extractFromCard(button, card);
    }

    var details = findProductDetails(button);
    if (details) {
      return extractFromDetails(button, details);
    }

    var wishlistRow = findWishlistRow(button);
    if (wishlistRow) {
      return extractFromWishlistRow(button, wishlistRow);
    }

    return null;
  };

  var isWishlistToggleButton = function (button) {
    if (!button) {
      return false;
    }
    if (
      button.classList.contains('wishlist-add-cart-btn') ||
      button.classList.contains('wishlist-remove-btn') ||
      button.hasAttribute('data-wishlist-clear') ||
      button.closest('.ma-wishlist-item__actions')
    ) {
      return false;
    }
    return true;
  };

  var setButtonState = function (button, active) {
    if (!button || !isWishlistToggleButton(button)) {
      return;
    }

    var icon = button.querySelector('i');
    button.classList.toggle('active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');

    if (!icon) {
      return;
    }

    icon.classList.remove('ph', 'ph-bold', 'ph-fill', 'ph-heart', 'text-main-two-600');

    if (button.classList.contains('wishlist-btn-two')) {
      icon.classList.add(active ? 'ph-fill' : 'ph-bold', 'ph-heart');
      return;
    }

    icon.classList.add(active ? 'ph-fill' : 'ph', 'ph-heart');
    if (active) {
      icon.classList.add('text-main-two-600');
    }
  };

  var syncButtons = function () {
    var itemIds = new Set(getWishlistItems().map(function (item) {
      return item.id;
    }));

    document.querySelectorAll('.wishlist-btn-two, .wishlist-btn, button[aria-label*="Wishlist"], button[title*="Wishlist"], button[data-wishlist-id]').forEach(function (button) {
      if (!isWishlistToggleButton(button)) {
        return;
      }
      var item = extractWishlistItem(button);
      var itemId = item ? item.id : button.getAttribute('data-wishlist-id');
      setButtonState(button, itemId ? itemIds.has(itemId) : false);
    });
  };

  var updateCount = function () {
    var count = getWishlistItems().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (counter) {
      counter.textContent = count;
      counter.classList.toggle('d-none', count === 0);
    });
  };

  var ensurePageShell = function () {
    var page = document.querySelector('[data-wishlist-page]');
    if (page) {
      return page;
    }

    var pathname = window.location.pathname.replace(/\/+$/, '') || '/';
    var params = new URLSearchParams(window.location.search);
    if (pathname !== '/pages/wishlist' || params.get('view') === 'compare') {
      return null;
    }

    var host = document.querySelector('.main-page-title + .rte') || document.querySelector('.page-width .rte') || document.querySelector('.rte');
    if (!host) {
      return null;
    }

    document.body.classList.add('wishlist-page');
    host.innerHTML = '' +
      '<div class="ma-wishlist" data-wishlist-page>' +
        '<div class="ma-wishlist-grid">' +
          '<section class="ma-wishlist-card ma-wishlist-list">' +
            '<div class="ma-wishlist-card__header">' +
              '<div>' +
                '<p class="ma-wishlist-eyebrow">Saved products</p>' +
                '<h2>Wishlist Items (<span data-wishlist-total>0</span>)</h2>' +
              '</div>' +
              '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost d-none" data-wishlist-clear>Clear Wishlist</button>' +
            '</div>' +
            '<div class="wishlist-page__empty ma-wishlist-empty d-none" data-wishlist-empty>' +
              '<div class="wishlist-page__empty-icon mx-auto mb-16"><i class="ph ph-heart"></i></div>' +
              '<h5 class="mb-8">Your wishlist is empty</h5>' +
              '<p class="text-gray-500 mb-20">Save products you love and compare them here before checkout.</p>' +
              '<a href="/" class="ma-wishlist-btn ma-wishlist-btn--primary">Browse Products</a>' +
            '</div>' +
            '<div class="ma-wishlist-items" data-wishlist-items></div>' +
          '</section>' +
          '<aside class="ma-wishlist-card ma-wishlist-summary">' +
            '<h4>Wishlist Summary</h4>' +
            '<div class="ma-wishlist-summary__row"><span>Saved items</span><strong data-wishlist-total>0</strong></div>' +
            '<div class="ma-wishlist-summary__row"><span>Store</span><strong>Moto Avenue</strong></div>' +
            '<p class="ma-wishlist-summary__note">Review your favorite riding essentials, then open a product to choose options and add it to cart.</p>' +
            '<a href="/" class="ma-wishlist-btn ma-wishlist-btn--primary">Continue Shopping</a>' +
          '</aside>' +
        '</div>' +
      '</div>';

    return host.querySelector('[data-wishlist-page]');
  };

  var renderPage = function () {
    var page = ensurePageShell();
    if (!page) {
      return;
    }

    var items = getWishlistItems();
    var list = page.querySelector('[data-wishlist-items]');
    var emptyState = page.querySelector('[data-wishlist-empty]');
    var totals = page.querySelectorAll('[data-wishlist-total]');
    var clearButton = page.querySelector('[data-wishlist-clear]');

    totals.forEach(function (total) {
      total.textContent = items.length;
    });

    if (clearButton) {
      clearButton.classList.toggle('d-none', items.length === 0);
    }

    if (!list || !emptyState) {
      return;
    }

    if (!items.length) {
      list.innerHTML = '';
      emptyState.classList.remove('d-none');
      return;
    }

    emptyState.classList.add('d-none');
    list.innerHTML = items.map(function (item) {
      return '' +
        '<article class="ma-wishlist-item" data-wishlist-card data-wishlist-id="' + escapeHtml(item.id) + '">' +
          '<div class="ma-wishlist-item__media">' +
            '<a href="' + escapeHtml(item.url) + '">' +
              (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '">' : '') +
            '</a>' +
          '</div>' +
          '<div class="ma-wishlist-item__body">' +
            (function() {
              var badgeHTML = '';
              var cPrice = item.comparePrice ? parseFloat(String(item.comparePrice).replace(/[^0-9.]/g, '')) : 0;
              var price = item.price ? parseFloat(String(item.price).replace(/[^0-9.]/g, '')) : 0;
              if (cPrice > price && price > 0) {
                var pct = Math.round(((cPrice - price) * 100) / cPrice);
                badgeHTML = '<span class="product-card__badge text-white" style="background-color: #b51f32; padding: 4px 8px; font-size: 12px; line-height: 1.2;">' + pct + '% off</span>';
              } else if (item.badge) {
                badgeHTML = '<span class="product-card__badge text-white" style="background-color: #b51f32; padding: 4px 8px; font-size: 12px; line-height: 1.2;">' + escapeHtml(item.badge) + '</span>';
              }
              return badgeHTML;
            })() +
            '<p class="ma-wishlist-item__vendor">' + escapeHtml(item.vendor) + '</p>' +
            '<h3><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a></h3>' +
            '<div class="ma-wishlist-item__meta">' +
              '<span><i class="ph-fill ph-storefront"></i> Saved for later</span>' +
            '</div>' +
          '</div>' +
          '<div class="ma-wishlist-item__side">' +
            '<div class="ma-wishlist-item__price">' +
              (item.comparePrice ? '<span>' + escapeHtml(item.comparePrice) + '</span>' : '') +
              (item.price ? '<strong>' + escapeHtml(item.price) + '</strong>' : '<strong>View price</strong>') +
            '</div>' +
            '<div class="ma-wishlist-item__actions">' +
              '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--primary wishlist-add-cart-btn"' + (item.variantId ? ' data-variant-id="' + escapeHtml(item.variantId) + '"' : '') + ' data-url="' + escapeHtml(item.url) + '">' +
                'Add <i class="ph ph-shopping-cart text-lg ms-1"></i>' +
              '</button>' +
              '<a href="' + escapeHtml(item.url) + '" class="ma-wishlist-btn ma-wishlist-btn--ghost ma-wishlist-btn--icon" title="View Product" aria-label="View Product"><i class="ph ph-eye text-lg"></i></a>' +
              '<button type="button" class="ma-wishlist-btn ma-wishlist-btn--ghost ma-wishlist-btn--icon wishlist-remove-btn" title="Remove from wishlist" aria-label="Remove" data-wishlist-id="' + escapeHtml(item.id) + '"><i class="ph ph-trash text-lg"></i></button>' +
            '</div>' +
          '</div>' +
        '</article>';
    }).join('');
  };

  var writeAndRefresh = function (items) {
    saveWishlist(items);
    syncButtons();
    updateCount();
    renderPage();
  };

  var toggleItem = function (item) {
    var items = getWishlistItems();
    var index = items.findIndex(function (storedItem) {
      return (item.id && storedItem.id === item.id) ||
        (item.handle && storedItem.handle && storedItem.handle === item.handle) ||
        (item.productId && storedItem.productId && storedItem.productId === item.productId) ||
        (item.variantId && storedItem.variantId && storedItem.variantId === item.variantId);
    });

    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.unshift(item);
    }

    writeAndRefresh(items);
  };

  var onDocumentClick = function (event) {
    var addToCartBtn = event.target.closest('.wishlist-add-cart-btn');
    if (addToCartBtn) {
      event.preventDefault();
      event.stopPropagation();
      var variantId = addToCartBtn.getAttribute('data-variant-id');
      var url = addToCartBtn.getAttribute('data-url');

      if (!variantId) {
        if (url && url !== '#') {
          window.location.href = url;
        }
        return;
      }

      if (!document.getElementById('ma-cart-spin-style')) {
        var spinStyle = document.createElement('style');
        spinStyle.id = 'ma-cart-spin-style';
        spinStyle.textContent = '@keyframes ma-cart-spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}';
        document.head.appendChild(spinStyle);
      }

      var originalContent = addToCartBtn.innerHTML;
      addToCartBtn.disabled = true;
      addToCartBtn.innerHTML = '<span style="display:inline-block;width:14px;height:14px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:ma-cart-spin 0.8s linear infinite;vertical-align:middle;margin-right:6px;"></span> Adding...';

      var addEndpoint = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';

      fetch(addEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1
          }]
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Unable to add item');
          }
          return response.json();
        })
        .then(function () {
          addToCartBtn.classList.add('added');
          addToCartBtn.innerHTML = '<svg class="icon icon-checkmark" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 18px; height: 18px; display: inline-block; flex-shrink: 0;"><path d="M10 3L4.5 8.5L2 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

          var cartEndpoint = (window.routes && window.routes.cart_url) ? (window.routes.cart_url + '.js') : '/cart.js';
          fetch(cartEndpoint)
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('moto:cart-updated', { detail: { cart: cart } }));
              var cartBadges = document.querySelectorAll('.cart-count-badge, .cart-count-bubble, [data-cart-count], .header__cart-count');
              cartBadges.forEach(function (badge) {
                badge.textContent = cart.item_count;
                badge.classList.toggle('d-none', cart.item_count === 0);
              });
            })
            .catch(function () {});

          setTimeout(function () {
            addToCartBtn.classList.remove('added');
            addToCartBtn.disabled = false;
            addToCartBtn.innerHTML = originalContent;
          }, 2000);
        })
        .catch(function () {
          if (url && url !== '#') {
            window.location.href = url;
          } else {
            addToCartBtn.disabled = false;
            addToCartBtn.innerHTML = originalContent;
          }
        });
      return;
    }

    var clearButton = event.target.closest('[data-wishlist-clear]');
    if (clearButton) {
      event.preventDefault();
      event.stopPropagation();
      writeAndRefresh([]);
      return;
    }

    var removeButton = event.target.closest('.wishlist-remove-btn');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      var itemId = removeButton.getAttribute('data-wishlist-id');
      writeAndRefresh(getWishlistItems().filter(function (item) {
        return item.id !== itemId;
      }));
      return;
    }

    var wishlistButton = event.target.closest('.wishlist-btn-two, .wishlist-btn, button[aria-label*="Wishlist"], button[title*="Wishlist"], button[data-wishlist-id]');
    if (!wishlistButton || !isWishlistToggleButton(wishlistButton)) {
      return;
    }

    if (!shouldRunFallback()) {
      return;
    }

    var item = extractWishlistItem(wishlistButton);
    if (!item) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    toggleItem(item);
  };

  var syncVariantState = function (scope) {
    if (!scope) {
      return;
    }

    var variantId = getVariantId(scope);
    var button = scope.querySelector('.wishlist-btn, .wishlist-btn-two, button[aria-label*="Wishlist"], button[title*="Wishlist"]');

    if (variantId) {
      scope.setAttribute('data-variant-id', variantId);
      if (button) {
        button.setAttribute('data-variant-id', variantId);
      }
    }
  };

  var initialize = function () {
    document.querySelectorAll('.pdp-info-card, [data-product-details]').forEach(syncVariantState);
    syncButtons();
    updateCount();
    renderPage();
  };

  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('change', function (event) {
    var variantInput = event.target.closest('.pdp-info-card input[name="id"], [data-product-details] input[name="id"]');
    if (variantInput) {
      syncVariantState(variantInput.closest('[data-product-details]'));
      syncButtons();
    }
  }, true);
  document.addEventListener('moto:wishlist-updated', initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('load', initialize, { once: true });
  window.setTimeout(initialize, 300);

  if (!window.__MOTO_WISHLIST_BRIDGE_OBSERVER && typeof MutationObserver !== 'undefined') {
    var observedContainers = document.querySelectorAll('#ProductGridContainer, .product-one-slider, .recommended, .hot-deals-slider');

    if (observedContainers.length) {
      var observer = new MutationObserver(function () {
        initialize();
      });

      observedContainers.forEach(function (container) {
        observer.observe(container, {
          childList: true,
          subtree: true
        });
      });
      window.__MOTO_WISHLIST_BRIDGE_OBSERVER = observer;
    }
  }

  window.__MOTO_WISHLIST_BRIDGE_BOUND = true;
})();
